import Feature9_2 from './Feature9_2'
export default Feature9_2
